type Inputs = {
    editorElement: HTMLElement;
    command: string;
    value?: string;
};

// Applies a formatting command (bold, lists, links, ...) to the current
// selection inside the editor. execCommand is deprecated but remains the
// pragmatic way to drive a contenteditable region without a heavy library.
export function applyCommand({ editorElement, command, value }: Inputs): void {
    editorElement.focus();
    document.execCommand(command, false, value);
}
